module.exports = __webpack_public_path__ + "static/media/teamsEvent.3a2a5b74.svg";